import React from 'react';
import AdminHeader from '../../globals/Layout/Admin/AdminHeader';
import TTypeOrganization from './Tables/TTypeOrganization';
const TypeOrganization: React.FC = () => {
    return (
        <div>
            <AdminHeader>Tipo de Organización</AdminHeader>  
            <TTypeOrganization/>        
        </div>

    );
};


export default TypeOrganization;